var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.005,
    height: 30.001,
    viewBox: "0 0 30.005 30.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pickup_store",
    transform: "translate(0.004 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x38_",
    d: "M29.388,78.888a.468.468,0,0,1,.472-.465.462.462,0,0,1,.465.465v6.888a.468.468,0,0,1-.465.472H9.9a.468.468,0,0,1-.465-.472V73.932a.462.462,0,0,1,.465-.465.468.468,0,0,1,.472.465V85.311H29.388Z",
    transform: "translate(-7.222 -56.249)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x37_",
    d: "M26.045,90.679a.474.474,0,0,1-.472.472.468.468,0,0,1-.465-.472V84.694a3.235,3.235,0,1,1,6.47,0v5.985a.474.474,0,0,1-.472.472.468.468,0,0,1-.465-.472V84.694a2.3,2.3,0,1,0-4.6,0Z",
    transform: "translate(-19.224 -62.368)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x36_",
    d: "M62.524,91.085h4.3V87.81h-4.3Zm4.776.937H62.059a.468.468,0,0,1-.472-.465V87.338a.468.468,0,0,1,.472-.465H67.3a.468.468,0,0,1,.472.465v4.218a.468.468,0,0,1-.472.465Z",
    transform: "translate(-47.153 -66.513)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_",
    d: "M40.715,107a.468.468,0,1,0-.472-.465.468.468,0,0,0,.472.465Z",
    transform: "translate(-30.812 -81.205)",
    fill: "#818181",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x34_",
    d: "M10.448,39.868v-.027l.312-5.8H8.96L7.9,39.9a1.407,1.407,0,0,0,.379.95,1.228,1.228,0,0,0,1.787,0,1.411,1.411,0,0,0,.379-.977Zm1.242-5.826-.306,5.826a1.442,1.442,0,0,0,.379.977,1.228,1.228,0,0,0,1.787,0,1.411,1.411,0,0,0,.379-.977h.007l-.16-2.923a.469.469,0,0,1,.937-.047l.153,2.943v.027h.007a1.442,1.442,0,0,0,.379.977,1.227,1.227,0,0,0,.9.385.472.472,0,0,1,0,.943,2.173,2.173,0,0,1-1.574-.684,2.525,2.525,0,0,1-.173-.206,2.475,2.475,0,0,1-.172.206,2.146,2.146,0,0,1-3.142,0,2.525,2.525,0,0,1-.173-.206,2.522,2.522,0,0,1-.172.206,2.146,2.146,0,0,1-3.142,0,2.526,2.526,0,0,1-.173-.206,2.524,2.524,0,0,1-.173.206,2.146,2.146,0,0,1-3.142,0,2.525,2.525,0,0,1-.173-.206,2.524,2.524,0,0,1-.173.206,2.141,2.141,0,0,1-2.949.179A2.282,2.282,0,0,1,.044,40.4,1.519,1.519,0,0,1,0,39.915a1.581,1.581,0,0,1,.12-.478l1.94-4.73a2.618,2.618,0,0,1,.923-1.169,2.446,2.446,0,0,1,1.4-.432h8.57a.469.469,0,0,1,0,.937H11.69Zm-3.674,0h-1.9L4.409,39.921a1.416,1.416,0,0,0,.379.923,1.229,1.229,0,0,0,1.787,0,1.411,1.411,0,0,0,.379-.977H6.96a.384.384,0,0,1,.007-.086Zm-2.87,0H4.389a1.5,1.5,0,0,0-.87.266,1.7,1.7,0,0,0-.591.757L.988,39.788a.581.581,0,0,0-.033.4,1.352,1.352,0,0,0,.458.757,1.23,1.23,0,0,0,1.674-.106,1.41,1.41,0,0,0,.379-.977h.007a.878.878,0,0,1,.013-.133Z",
    transform: "translate(0 -25.347)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x33_",
    d: "M59.083,112.526a.468.468,0,0,1-.472-.465.474.474,0,0,1,.472-.472h6.636a.468.468,0,0,1,.465.472.462.462,0,0,1-.465.465Z",
    transform: "translate(-44.875 -85.436)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x32_",
    d: "M78.929,10.961,72.9,21.164a.462.462,0,0,1-.638.166.432.432,0,0,1-.172-.172l-6.026-10.2a.148.148,0,0,0-.02-.033,7.625,7.625,0,0,1-.678-1.707,7.457,7.457,0,0,1-.232-1.853,7.367,7.367,0,1,1,13.8,3.58ZM72.5,2.9a4.467,4.467,0,1,1-3.171,1.3A4.467,4.467,0,0,1,72.5,2.9ZM75,4.869a3.538,3.538,0,1,0,.563,4.272A3.538,3.538,0,0,0,75,4.869ZM72.5,20.008l5.627-9.526a6.424,6.424,0,1,0-11.858-1.5,6.761,6.761,0,0,0,.591,1.488l.007.013Z",
    transform: "translate(-49.867)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x31_",
    d: "M89.556,22.278a2.168,2.168,0,0,1,1.514.631,2.144,2.144,0,1,1-3.036,3.029c-.007-.007-.013-.02-.026-.026a2.15,2.15,0,0,1,.026-3c.013-.007.02-.02.033-.027a2.14,2.14,0,0,1,1.488-.6Zm.85,1.289a1.22,1.22,0,0,0-1.687-.013l-.02.02a1.194,1.194,0,0,0-.352.85,1.214,1.214,0,0,0,.333.837l.02.02a1.207,1.207,0,0,0,1.707-1.707Z",
    transform: "translate(-66.924 -17.057)",
    fill: "#818181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupStore);
export default __webpack_public_path__ + "static/media/pickup_store.dcbf53e01bd66c2d80499725bf7db31c.svg";
export { ForwardRef as ReactComponent };